import { useBreakpoints } from '@/utils/useBreakpoints'

import styles from './squadbusters.module.scss'

export const SquadSeparator = () => {
  const from = useBreakpoints().from
  const isDesktop = from('tablet')
  const isTablet = from('tablet-small')

  return (
    <div className={styles.separatorContainer}>
      {isDesktop ? (
        <svg
          className={styles.svgElement}
          xmlns="http://www.w3.org/2000/svg"
          width="100%"
          height="108"
          viewBox="0 0 971 108"
          fill="none"
        >
          <path
            d="M213.085 44.7063L0.5 57.7876V107.784L746.491 47.8825L737 62.3386L970.754 48.2687V0.09338L201.654 62.3371L213.085 44.7063Z"
            fill="black"
          />
        </svg>
      ) : isTablet ? (
        <svg
          className={styles.svgElement}
          xmlns="http://www.w3.org/2000/svg"
          width="100%"
          height="75"
          viewBox="0 0 644 75"
          fill="none"
        >
          <path
            d="M212.585 11.9226L0 25.0039V75L419.738 47.7891L410.246 62.2452L644 48.1753V0L201.154 29.5533L212.585 11.9226Z"
            fill="black"
          />
        </svg>
      ) : (
        <svg
          className={styles.svgElement}
          xmlns="http://www.w3.org/2000/svg"
          width="100%"
          height="75"
          viewBox="0 0 390 75"
          fill="none"
        >
          <path
            d="M86.5845 11.9226L-126 25.0039V75L293.738 47.7891L284.246 62.2452L518 48.1753V0L75.1539 29.5533L86.5845 11.9226Z"
            fill="black"
          />
        </svg>
      )}
    </div>
  )
}
